export default __webpack_public_path__ + "static/media/kitchen3-before1-768w.2a19675f.png";